// Main plugin JS entry.
// Resource Centre filtering logic is in `library/js/libs/resource-filtering.js`.
// Keep this file as the primary bundle entry for future global behaviors.
import './libs/resource-filtering';

jQuery(document).ready(function($) {
		/* ====================== ANIMATE STATS ======================  */
		"use strict";
		if (window.counterUp && typeof window.counterUp["default"] === "function") {
			var counterUp = window.counterUp["default"];
			var $counters = $(".statistic-number span");

			$counters.each(function (ignore, counter) {
				counterUp(counter, {
					duration: 1250,
				});
			});
		}


/* ====================== Mobile Filter Trigger ======================  */
	$('.mobile-filter-trigger').on("click", function() {
		$('.filter-sidebar').addClass('active');
		$('body').addClass('noscroll');
	});
	$('.filter-sidebar .close').on("click", function() {
		$('.filter-sidebar').removeClass('active');
		$('body').removeClass('noscroll');
	});

/* ====================== Gateway Modal ======================  */
	$('.unlock-access-trigger').on("click", function() {
		$('.gateway-popup').addClass('active');
		$('body').addClass('noscroll');
	});

	$('.gateway-popup .modal-close').on("click", function() {
		$('.gateway-popup').removeClass('active');
		$('body').removeClass('noscroll');
	});

	/* ====================== COPY URL TO CLIPBOARD ======================  */
	$('.social-share-link-url').on("click", function() {
		var dummy = document.createElement('input'),
		text = window.location.href;

		document.body.appendChild(dummy);
		dummy.value = text;
		dummy.select();
		document.execCommand('copy');
		document.body.removeChild(dummy);

		$(this).addClass('copied');

		setTimeout(
		function() {
			$('.social-share-link-url').removeClass('copied');
		}, 2000);
	});

// ===== SMOOTH SCROLLING AND PADDING ===== //
	var headerHeight = $('header').outerHeight();
	headerHeight = headerHeight + 30;
	document.documentElement.style.setProperty('--headerHeight', `${headerHeight}px`);

// ===== CONTENTS HIGHLIGHTING ON SCROLL ===== //
	function highlightMenu(blockAnchor) {
		var blockID = $(blockAnchor).attr('id');

		$('.resource-contents-list .resources-contents-item a').each(function() {
			if ($(this).attr('href') === '#' + blockID) {
				$('.resource-contents-list .resources-contents-item').removeClass('active');
				$(this).parent('.resources-contents-item').addClass('active');
			}
		});
	}

	const blockAnchors = document.querySelectorAll('.hawrc-block[id]');
	const observer = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				highlightMenu(entry.target);
			}
		});
	}, {
		rootMargin: '-50% 0px -50% 0px',
		threshold: 0
	});
	blockAnchors.forEach(el => observer.observe(el));

	// Also highlight menu item on click
	$('.resource-contents-list').on('click', '.resources-contents-item a', function(e) {
		$('.resource-contents-list .resources-contents-item').removeClass('active');
		$(this).parent('.resources-contents-item').addClass('active');
	});

	const wrap = document.querySelector('.hawrc-grid');
	const wrapObserver = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			if (!entry.isIntersecting) {
				$('.resource-contents-list .resources-contents-item').removeClass('active');
			}
		});
	}, {
		rootMargin: '-50% 0px -50% 0px',
		threshold: 0
	});
	if (wrap) wrapObserver.observe(wrap);

// ===== PROGRESS BAR ===== //
	const $progressBarContainer = $('.progress-bar');
	const $progressBar = $('.progress-bar .progress');
	const $header = $('header');

	if (($progressBarContainer.length && $header.length) || $progressBar.length) {
		let isFixed = false;
		let initialBarOffset = $progressBarContainer.offset().top;

		// Combined function: manages bar sticky state and reading progress
		const onScrollOrResize = function(triggeredByResize = false) {
			const $window = $(window);
			const $document = $(document);
			const scrollTop = $window.scrollTop();

			// Handle stickiness of progress bar container
			if ($progressBarContainer.length && $header.length) {
				const headerHeight = $header.outerHeight();
				if (scrollTop >= initialBarOffset - headerHeight) {
					if (!isFixed) {
						$progressBarContainer
							.addClass('progress-bar-fixed')
							.css({
								position: 'fixed',
								top: $header[0].getBoundingClientRect().bottom + 'px',
								left: '0',
								width: '100%',
								'z-index': 9999999
							});
						isFixed = true;
					}
				} else {
					if (isFixed) {
						$progressBarContainer
							.removeClass('progress-bar-fixed')
							.css({
								position: '',
								top: '',
								left: '',
								width: '',
								'z-index': ''
							});
						isFixed = false;
					}
				}
			}

			// Handle animated reading progress bar
			if ($progressBar.length) {
				const docHeight = $document.height();
				const winHeight = $window.height();
				const scrollable = docHeight - winHeight;

				let percent = 0;
				if (scrollable > 0) {
					percent = (scrollTop / scrollable) * 100;
					percent = Math.max(0, Math.min(percent, 100));
				}
				$progressBar.css('width', percent + '%');
			}

			// If triggered by resize, recalc the bar offset after layout settles
			if (triggeredByResize && $progressBarContainer.length) {
				setTimeout(() => {
					initialBarOffset = $progressBarContainer.offset().top;
					// Re-run to update sticky state with new offset
					onScrollOrResize();
				}, 100);
			}
		};

		$(window).on('scroll', function () {
			onScrollOrResize(false);
		});
		$(window).on('resize', function () {
			onScrollOrResize(true);
		});

		// Initialize on load
		onScrollOrResize(true);
	}

// ===== VIDEO FUNCTIONALITY ===== //
	$('.hawrc-resources-inner-content-column').on( 'click', '.hawrc-video', function( e ){
		$(this).toggleClass('video-playing');
		const $video = $(this).find('video').get(0);
		if ($video) {
			if ($video.paused) {
				$video.play();
			} else {
				$video.pause();
			}
		}
	});
});